<template>
    <!--
      BLOCO S — item 36: "Possibilitar a criação de campos personalizados para algumas
      funcionalidades do sistema."

      "Algumas funcionalidades" é literal: a lista de entidades vem do backend
      (`/catalogo`) e é fechada. Esta tela NUNCA envia nome de tabela ou de coluna — envia
      a chave da entidade, e o backend resolve o resto.
    -->
    <div class="main">
        <el-form label-position="top">
            <el-row :gutter="10">
                <el-col :xs="24" :sm="12">
                    <el-form-item label="Funcionalidade">
                        <el-select v-model="entidade" @change="carregar()" placeholder="Selecione"
                                   style="width: 100%;">
                            <el-option v-for="e in catalogo.entidades" :key="e.entidade"
                                       :label="e.rotulo" :value="e.entidade"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12" class="u-text-right">
                    <el-button type="primary" class="u-mt-30" :disabled="!entidade" @click="abrirNovo()">
                        <i class="el-icon-plus"></i> NOVO CAMPO
                    </el-button>
                </el-col>
            </el-row>
        </el-form>

        <el-alert v-if="erro" :title="erro" type="error" :closable="false" class="u-mb-15"></el-alert>

        <el-alert v-if="entidade" type="info" :closable="false" class="u-mb-15"
                  title="Campo personalizado é cadastro complementar: não entra em cálculo de média, frequência nem situação acadêmica."></el-alert>

        <div v-if="carregando" class="u-text-center u-mt-20">Carregando...</div>

        <el-table v-else-if="entidade" :data="campos" border size="mini"
                  empty-text="Nenhum campo personalizado definido para esta funcionalidade.">
            <el-table-column prop="ordem" label="Ordem" width="70"></el-table-column>
            <el-table-column prop="rotulo" label="Rótulo" min-width="180"></el-table-column>
            <el-table-column prop="chave" label="Chave" width="150"></el-table-column>
            <el-table-column label="Tipo" width="110">
                <template slot-scope="s">{{ rotuloTipo(s.row.tipo) }}</template>
            </el-table-column>
            <el-table-column label="Obrigatório" width="100">
                <template slot-scope="s">{{ s.row.obrigatorio ? 'Sim' : 'Não' }}</template>
            </el-table-column>
            <el-table-column label="Escopo" width="110">
                <template slot-scope="s">{{ s.row.escopo === 'rede' ? 'Rede' : 'Instituição' }}</template>
            </el-table-column>
            <el-table-column label="Opções" min-width="160">
                <template slot-scope="s">
                    <span v-if="!s.row.opcoes.length" class="vazio">—</span>
                    <el-tag v-for="(o, i) in s.row.opcoes" :key="i" size="mini" class="u-mr-5">{{ o }}</el-tag>
                </template>
            </el-table-column>
            <el-table-column label="" width="200">
                <template slot-scope="s">
                    <el-button size="mini" @click="abrirEdicao(s.row)">EDITAR</el-button>
                    <el-button class="u-ml-10" size="mini" type="danger" @click="excluir(s.row)">EXCLUIR</el-button>
                </template>
            </el-table-column>
        </el-table>

        <el-dialog :title="form.id ? 'Editar campo' : 'Novo campo'" :visible.sync="dialog" width="480px">
            <el-form label-position="top" class="u-mt-20">
                <el-form-item label="Rótulo">
                    <el-input v-model="form.rotulo" maxlength="191"></el-input>
                </el-form-item>

                <el-row :gutter="10">
                    <el-col :span="12">
                        <el-form-item label="Tipo">
                            <!-- Tipos vêm do backend; a tela não inventa tipo. -->
                            <el-select v-model="form.tipo" :disabled="!!form.id" style="width: 100%;">
                                <el-option v-for="t in catalogo.tipos" :key="t" :label="rotuloTipo(t)" :value="t"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="Ordem">
                            <el-input v-model="form.ordem" type="number"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-form-item v-if="form.tipo === 'selecao'" label="Opções (uma por linha)">
                    <el-input v-model="opcoesTexto" type="textarea" :rows="4"
                              placeholder="Uma opção por linha"></el-input>
                </el-form-item>

                <el-row :gutter="10">
                    <el-col :span="12">
                        <el-form-item label="Tamanho máximo (opcional)">
                            <el-input v-model="form.tamanho_max" type="number"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-checkbox v-model="form.obrigatorio" class="u-mt-30">Preenchimento obrigatório</el-checkbox>
                    </el-col>
                </el-row>

                <el-form-item label="Escopo">
                    <el-select v-model="form.instituicao_id" clearable placeholder="Toda a rede" style="width: 100%;">
                        <el-option v-for="(item, i) in $store.state.instituicoes" :key="i"
                                   :label="item.nome" :value="item.id"></el-option>
                    </el-select>
                    <small class="dica">Deixe em branco para valer em toda a rede (somente perfis da rede).</small>
                </el-form-item>

                <el-alert v-if="erroForm" :title="erroForm" type="error" :closable="false"></el-alert>
            </el-form>

            <span slot="footer">
                <el-button @click="dialog = false">CANCELAR</el-button>
                <el-button class="u-ml-10" type="primary" :loading="salvando" @click="salvar()">SALVAR</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
const TIPOS = { texto: 'Texto', numero: 'Número', data: 'Data',
                selecao: 'Seleção', booleano: 'Sim/Não' }

export default {
    data: () => ({
        catalogo: { entidades: [], tipos: [] },
        entidade: '',
        campos: [],
        form: {},
        opcoesTexto: '',
        dialog: false,
        carregando: false,
        salvando: false,
        erro: '',
        erroForm: ''
    }),
    mounted () {
        this.getCatalogo()
    },
    methods: {
        /** A lista de entidades permitidas é do backend. */
        getCatalogo () {
            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/campo-personalizado/catalogo`,
                            this.$store.getters.getHeaderAuth).then(r => {
                const d = r.data || {}
                if (d.erro || d.error) { this.erro = d.erro || d.error; return }
                this.catalogo = d
            }).catch(e => this.tratarFalha(e))
        },

        carregar () {
            this.campos = []
            this.erro = ''

            if (!this.entidade) return

            this.carregando = true

            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/campo-personalizado/definicoes/${this.entidade}`,
                            this.$store.getters.getHeaderAuth).then(r => {
                this.carregando = false
                const d = r.data || {}
                if (d.erro || d.error) { this.erro = d.erro || d.error; return }
                this.campos = d.campos || []
            }).catch(e => { this.carregando = false; this.tratarFalha(e) })
        },

        abrirNovo () {
            this.erroForm = ''
            this.opcoesTexto = ''
            this.form = { entidade: this.entidade, rotulo: '', tipo: 'texto', ordem: this.campos.length + 1,
                          obrigatorio: false, tamanho_max: '', instituicao_id: '' }
            this.dialog = true
        },

        abrirEdicao (linha) {
            this.erroForm = ''
            this.opcoesTexto = (linha.opcoes || []).join('\n')
            this.form = Object.assign({}, linha, { entidade: this.entidade })
            this.dialog = true
        },

        salvar () {
            this.erroForm = ''
            this.salvando = true

            const payload = Object.assign({}, this.form)

            if (payload.tipo === 'selecao') {
                payload.opcoes = this.opcoesTexto.split('\n').map(o => o.trim()).filter(o => o)
            }

            const url = payload.id
                ? `${this.$store.state.config.baseUrlApi}/api/campo-personalizado/definicao/${payload.id}`
                : `${this.$store.state.config.baseUrlApi}/api/campo-personalizado/definicao`

            this.$axios.post(url, payload, this.$store.getters.getHeaderAuth).then(r => {
                this.salvando = false
                const d = r.data || {}

                if (d.erro || d.error) { this.erroForm = d.erro || d.error; return }

                this.dialog = false
                this.$message.success(d.mensagem || 'Campo salvo.')
                this.carregar()
            }).catch(e => { this.salvando = false; this.tratarFalha(e, 'erroForm') })
        },

        excluir (linha) {
            this.$confirm(`Desativar o campo "${linha.rotulo}"? Os valores já registrados são preservados.`,
                          'Confirmação', { type: 'warning' }).then(() => {
                this.$axios.delete(`${this.$store.state.config.baseUrlApi}/api/campo-personalizado/definicao/${linha.id}`,
                                   this.$store.getters.getHeaderAuth).then(r => {
                    const d = r.data || {}
                    if (d.erro || d.error) { this.$message.error(d.erro || d.error); return }
                    this.$message.success(d.mensagem || 'Campo desativado.')
                    this.carregar()
                }).catch(e => this.tratarFalha(e))
            }).catch(() => {})
        },

        rotuloTipo (t) { return TIPOS[t] || t },

        tratarFalha (e, campo) {
            const d = (e && e.response && e.response.data) ? e.response.data : {}
            const msg = d.erro || d.error || 'Não foi possível concluir a operação.'
            if (campo) this[campo] = msg
            else this.$message.error(msg)
        }
    }
}
</script>

<style scoped>
.vazio { color: #c0c4cc; }
.dica { color: #909399; font-size: 11px; }
</style>
